import React from "react";
interface IconProps {
    fill: string;
    class?: string;
    className?: string;
    height: number;
}


export const SecurityIcon = (props: IconProps) => (
    <svg fill={props.fill} className={props.class} viewBox="0 0 511.996 511.996" width={props.height} height={props.height} >
        <g>
            <path d="M256.004,159.996c-17.641,0-32,14.359-32,32v32h64v-32C288.004,174.355,273.645,159.996,256.004,159.996z" />
            <path d="M461.832,3.145c-11.111-5.328-24.266-3.797-33.893,3.922c-39.982,32.141-111.951,32.125-151.873,0.016
		c-11.719-9.438-28.406-9.422-40.125-0.016C195.975,39.207,123.975,39.191,84.068,7.082c-9.611-7.734-22.81-9.266-33.877-3.938
		C39.086,8.457,32.008,19.691,32.008,32.004l-0.016,256c0,100.297,80.406,183.555,215.074,222.727
		c2.922,0.844,5.922,1.266,8.939,1.266c3.014,0,6.016-0.422,8.938-1.266c134.67-39.172,215.061-122.414,215.061-222.727v-256
		C480.004,19.691,472.941,8.457,461.832,3.145z M352.004,319.996c0,17.68-14.326,32-32,32h-128c-17.674,0-32-14.32-32-32v-64
		c0-17.672,14.326-32,32-32v-32c0-35.281,28.703-64,64-64c35.297,0,64,28.719,64,64v32c17.674,0,32,14.328,32,32V319.996z"/>
            <path d="M256.004,271.996c-8.836,0-16,7.164-16,16c0,8.844,7.164,16,16,16c8.836,0,16-7.156,16-16
		C272.004,279.16,264.84,271.996,256.004,271.996z"/>
        </g>



    </svg >
)


// WEBPACK FOOTER //
// ./src/layout/icons/Security.tsx